import axios from 'axios'
import React from 'react'
import { baseUrl } from '../../config/clientsConfig'

const liveTrackService = {
    getLiveTrackMultiple: async (teamId) => {
        return axios.get(`${baseUrl}/geo-locations?teamId=${teamId}`)
    },
    getLiveTrackSingle: async (userId , date) => {
        return axios.get(`${baseUrl}/geo-locations/timeline?userId=${userId}&date=${date}`)
    },
    getAllUsersGeoLocations: async (body) => {
        return axios.post(`${baseUrl}/geo-locations/all`, body)
    },
    getPropertyLocations: async (body) => {
        return axios.get(`${baseUrl}/properties/geopoints`, body)
    }
}

export default liveTrackService